const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/ErrorMsg/ErrorMsg.tsx';
import { FormattedMessage } from 'react-intl';

import textMap from './translations';
import { Logger } from '@cistec/common_web/services/KisLoggerService';
import { errorMsgStyle } from 'App/pages/LoginPage/styles';

const Log = Logger('ErrorMsg');

/**
 * React props
 */
export interface IErrorMsgProps {
    /**
     * Error constant. This may either be one of LoginError (@see loginDefs.ts) or
     * one of PATAPI's errors (@see errors.ts in patapi repository).
     */
    error?: string;
}

/**
 * Functional React component
 */
export const ErrorMsg = (props: IErrorMsgProps) => {
    if (!props.error) {
        return null;
    }

    const txt = (textMap as any)[props.error];

    if (!txt) {
        // There is no translation for this error.
        Log.error(`Please provide a translation for this error: ${props.error}`);
        return <p>? {props.error}</p>;
    }

    return (
        <p className={errorMsgStyle}>
            <FormattedMessage id={txt.id} />
        </p>
    );
};
